import React from "react";
import { useTranslation } from "react-i18next";
import {
  createPrimitiveSymbol3DMetadata,
} from "../../features/floorplan3d/symbols/registry/primitiveSymbol3DConfig";
import { DINING_SYMBOL_LIBRARY_DIMENSIONS } from "../../features/floorplan3d/symbols/dining/diningSymbolSvgGenerator";
import { DINING_ARMCHAIR_SIZE_M } from "../../features/floorplan3d/symbols/dining/diningLayoutConstants";
import {
  createDefaultSmartRectangleTableConfig,
  createDefaultSmartRoundTableConfig,
  createSmartTable3DMetadata,
} from "../../features/floorplan3d/symbols/dining/smartTableConfig";
import {
  BOOK_SHELF_LIBRARY_KEY,
  createBookShelf3DMetadata,
  createDefaultBookShelfConfig,
} from "../../features/floorplan3d/symbols/livingRoom/bookShelfConfig";
import BookShelfIcon from "../../assets/symbols/bookshelf.svg";
import {
  SymbolLibraryTabBar as SymbolLibraryTabBarControl,
  SymbolLibraryTabBarProps,
} from "./SymbolLibraryTabBar";
import {
  isSymbolLibraryAssetDisabledIn3D,
  isSymbolLibraryTabDisabledIn3D,
} from "./symbolLibrary3DAvailability";
import { compareSymbolLibraryAssets } from "./symbolLibrarySorting";
// Note: These SVG files don't exist in the current project structure
import SpotlightIcon from '../../assets/symbols/belysning2_alt.svg';
import LightFixIcon from '../../assets/symbols/belysning2.svg';
// import DoubleDoorSVG from '../../../symbols/FLOOR PLAN/Wall Attachments/Dubbeldörr.svg';
import Sofa2seatIcon from '../../assets/symbols/2-sist soffa-01.svg';
import Sofa3seatIcon from '../../assets/symbols/3 sists soffa-01.svg';
import ModularSofaIcon from '../../assets/symbols/modulsoffa-01.svg';
import ChaiseSofaIcon from '../../assets/symbols/schäslong-01.svg';
import LoungeChair1Icon from '../../assets/symbols/fåtölj 3-01.svg';
import LoungeChair2Icon from '../../assets/symbols/fåtölj  2-01.svg';
import ArmChairIcon from '../../assets/symbols/Fåtölj standard-01.svg';
import OctagonalCoffTabIcon from '../../assets/symbols/poly 1-01.svg';
import PentagonalCoffTabIcon from '../../assets/symbols/poly 2-01.svg';
import HexagonalCoffTabIcon from '../../assets/symbols/poly 3-01.svg';
import OrganicCoffTabIcon from '../../assets/symbols/soffbord 2-01.svg';
import OvalCoffTabIcon from '../../assets/symbols/matbord-01.svg';
import Chair6TableIcon from '../../assets/symbols/6 bord ny-01.svg';
import Chair4TableIcon from '../../assets/symbols/4-bord ny-01.svg';
import Chair2TableIcon from '../../assets/symbols/2-bord ny-01.svg';
import PlainTableIcon from '../../assets/symbols/plain table.svg';
import PlainRoundTableIcon from '../../assets/symbols/plain round table.svg';
import RoundTableIcon from '../../assets/symbols/runt bord ny-01.svg';
import ArmChairDRIcon from '../../assets/symbols/stol 2-01.svg';
import ChairSVG from '../../assets/symbols/stol ny-01.svg';
import DishWasherIcon from '../../assets/symbols/dishwasher.svg';
import BasinIcon from '../../assets/symbols/handfat ny-01.svg';
import BathtubIcon from '../../assets/symbols/badkar 1 ny-01.svg';
import ToiletIcon from '../../assets/symbols/toa ny-01.svg';
import ShowerIcon from '../../assets/symbols/dusch.svg';
import KingBedIcon from '../../assets/symbols/dubbelsäng ny-01.svg';
import SingleBedIcon from '../../assets/symbols/enkelsäng ny-01.svg';
import PlantSymbol from '../../assets/symbols/växt.svg';
import Curtain1Icon from '../../assets/symbols/Gardin.svg';
import Curtain2Icon from '../../assets/symbols/Gardin 2.svg';
import Hanger1Icon from '../../assets/symbols/galgar 1 ny-01.svg';
import Hanger2Icon from '../../assets/symbols/galgar 3 ny-01.svg';
import Hanger3Icon from '../../assets/symbols/galgar 4 ny-01.svg';
import Hanger4Icon from '../../assets/symbols/galgar 2 ny-01.svg';
import VoidIcon from '../../assets/symbols/void-icon.svg';

// Preview images
import singleDoorPreview from '../../assets/symbolsIcons/Single door_Rityta 1.png';
import slidingDoorPreview from '../../assets/symbolsIcons/Sliding door_Rityta 1.png';
import doubleDoorPreview from '../../assets/symbolsIcons/Double door_Rityta 1.png';
import windowPreview from '../../assets/symbolsIcons/Window_Rityta 1.png';
import twoSeatSofaPreview from '../../assets/symbolsIcons/2 Seat sofa_Rityta 1.png';
import threeSeatSofaPreview from '../../assets/symbolsIcons/3 Seat sofa_Rityta 1.png';
import modularSofaPreview from '../../assets/symbolsIcons/Modular sofa_Rityta 1.png';
import chaiseSofaPreview from '../../assets/symbolsIcons/Chaise sofa_Rityta 1.png';
import loungeChair1Preview from '../../assets/symbolsIcons/Lounge chair 1_Rityta 1.png';
import loungeChair2Preview from '../../assets/symbolsIcons/Lounge chair 2_Rityta 1.png';
import armChair1Preview from '../../assets/symbolsIcons/Armchair 1_Rityta 1.png';
import armChair2Preview from '../../assets/symbolsIcons/Armchair 2_Rityta 1.png';
import octagonalPreview from '../../assets/symbolsIcons/Octagon_Rityta 1.png';
import pentagonalPreview from '../../assets/symbolsIcons/Pentagon_Rityta 1.png';
import hexagonalPreview from '../../assets/symbolsIcons/Hexagon_Rityta 1.png';
import lightingFixturePreview from '../../assets/symbolsIcons/Lighting fixture_Rityta 1.png';
import coffeeTable1Preview from '../../assets/symbolsIcons/Coffee table 1_Rityta 1.png';
import coffeeTable2Preview from '../../assets/symbolsIcons/Oval coffee table2_Rityta 1.png';
import spotlightPreview from '../../assets/symbolsIcons/Spotlight_Rityta 1.png';
import squarePreview from '../../assets/symbolsIcons/Square_Rityta 1.png';
import trianglePreview from '../../assets/symbolsIcons/Triangle_Rityta 1.png';
import circlePreview from '../../assets/symbolsIcons/Circle_Rityta 1.png';
import showerPreview from '../../assets/symbolsIcons/Shower_Rityta 1.png';
import kingBedPreview from '../../assets/symbolsIcons/Double bed 2_Rityta 1.png';
import singleBedPreview from '../../assets/symbolsIcons/Single bed_Rityta 1.png';
import rectangulrStairPreview from '../../assets/symbolsIcons/Rectangular stair_Rityta 1.png';
import circleStairPreview from '../../assets/symbolsIcons/Circular stair_Rityta 1.png';
import { TurnStairsIcon } from '../icons/TurnStairsIcon';
import plantPreview from '../../assets/symbolsIcons/Plant 2_Rityta 1.png';
import curtain1Preview from '../../assets/symbolsIcons/Curtain 1_Rityta 1.png';
import curtain2Preview from '../../assets/symbolsIcons/Curtain 2_Rityta 1.png';
import hanger1Preview from '../../assets/symbolsIcons/Hangers 4_Rityta 1.png';
import hanger2Preview from '../../assets/symbolsIcons/Hangers 3_Rityta 1.png';
import hanger3Preview from '../../assets/symbolsIcons/Hangers 2_Rityta 1.png';
import hanger4Preview from '../../assets/symbolsIcons/Hangers 1_Rityta 1.png';
import chairPreview from '../../assets/symbolsIcons/Chair_Rityta 1.png';
import basinPreview from '../../assets/symbolsIcons/Basin_Rityta 1.png';
import bathtubPreview from '../../assets/symbolsIcons/Bathtub_Rityta 1.png';
import toiletPreview from '../../assets/symbolsIcons/Toilet_Rityta 1.png';
import voidPreview from '../../assets/symbolsIcons/Void_Rityta 1.png';

import NoSVGIcon from '../../assets/defaultIcon.png';

type WebpackRequireContext = {
  keys: () => string[];
  <T = string>(id: string): T;
};
declare const require: {
  context: (directory: string, useSubdirectories?: boolean, regExp?: RegExp) => WebpackRequireContext;
};

export interface LibrarySymbolAsset {
  id: string;
  tab: string;
  category: string;
  label: string;
  labelKey?: string;
  src: string;
  /** Optional React preview icon; when set, rendered instead of the img src. */
  Icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  fileName: string;
  legacyType?: string;
  svgOptions?: Record<string, any>;
  scaleReliable?: boolean;
}

type SymbolLibrary = Record<string, Record<string, LibrarySymbolAsset[]>>;

const SYMBOL_TAB_KEYS: Record<string, string> = {
  FLOOR_PLAN: "symbols.tabs.floorPlan",
  ELEVATION: "symbols.tabs.elevation",
};

const SYMBOL_CATEGORY_KEYS: Record<string, string> = {
  "Wall Attachments": "symbols.categories.wallAttachments",
  Stairs: "symbols.categories.stairs",
  "Living Room": "symbols.categories.livingRoom",
  "Dining Area": "symbols.categories.diningArea",
  Lighting: "symbols.categories.lighting",
  Kitchen: "symbols.categories.kitchen",
  Bathroom: "symbols.categories.bathroom",
  Bedroom: "symbols.categories.bedroom",
  Office: "symbols.categories.office",
  Botanicals: "symbols.categories.botanicals",
  "Symbols & Signs": "symbols.categories.symbolsAndSigns",
};

const MANUAL_LABEL_KEYS: Record<string, string> = {
  "MANUAL/Door": "symbols.singleDoor",
  "MANUAL/SlidingDoor": "symbols.slidingDoor",
  "MANUAL/GlassSlidingDoor": "symbols.glassSlidingDoor",
  "MANUAL/DoubleDoor": "symbols.doubleDoor",
  "MANUAL/Window": "symbols.window",
  "MANUAL/void-symbol": "symbols.void",
  "MANUAL/CircleStairs": "symbols.circularStairs",
  "MANUAL/RectStairs": "symbols.rectangularStairs",
  "MANUAL/TurnStairs": "symbols.turnStairs",
  "MANUAL/Lounge-2-seat-sofa": "symbols.twoSeatSofa",
  "MANUAL/Lounge-3-seat-sofa": "symbols.threeSeatSofa",
  "MANUAL/Modular-sofa": "symbols.modularSofa",
  "MANUAL/Chaise-sofa": "symbols.chaiseSofa",
  "MANUAL/Lounge-chair-1": "symbols.loungeChair",
  "MANUAL/Lounge-chair-2": "symbols.loungeChair",
  "MANUAL/Armchair": "symbols.armchair",
  "MANUAL/Octagonal-coffee-table": "symbols.octagonalCoffeeTable",
  "MANUAL/Pentagonal-coffee-table": "symbols.pentagonalCoffeeTable",
  "MANUAL/Hexagonal-coffee-table": "symbols.hexagonalCoffeeTable",
  "MANUAL/Oval-coffee-table": "symbols.coffeeTable1",
  "MANUAL/Oval-coffee-table-2": "symbols.coffeeTable2",
  [BOOK_SHELF_LIBRARY_KEY]: "symbols.bookShelf",
  "MANUAL/smart-rectangular-table": "symbols.smartRectangularTable",
  "MANUAL/smart-round-table": "symbols.smartRoundTable",
  "MANUAL/plain-table": "symbols.plainTable",
  "MANUAL/plain-round-table": "symbols.plainRoundTable",
  "MANUAL/6-chair-table": "symbols.sixChairTable",
  "MANUAL/4-chair-table": "symbols.fourChairTable",
  "MANUAL/2-chair-table": "symbols.twoChairTable",
  "MANUAL/round-table": "symbols.roundTable",
  "MANUAL/chair": "symbols.chair",
  "MANUAL/armchair-dining": "symbols.armchair",
  "MANUAL/basin": "symbols.basin",
  "MANUAL/bathtub": "symbols.bathtub",
  "MANUAL/toilet": "symbols.toilet",
  "MANUAL/shower": "symbols.shower",
  "MANUAL/dishwasher": "symbols.dishwasher",
  "MANUAL/king-bed": "symbols.kingBed",
  "MANUAL/single-bed": "symbols.singleBed",
  "MANUAL/plant": "symbols.plant",
  "MANUAL/hangers-1": "symbols.hangers1",
  "MANUAL/hangers-2": "symbols.hangers2",
  "MANUAL/hangers-3": "symbols.hangers3",
  "MANUAL/hangers-4": "symbols.hangers4",
  "MANUAL/spotlight": "symbols.spotlight",
  "MANUAL/lighting-fixture": "symbols.lightingFixture",
};

const symbolsContext = require.context("../../assets/symbols-library", true, /\.svg$/i);

// Per-file SVG options configuration
// Key format: "TAB/CATEGORY/filename.svg" (full path from symbols-library)
// If not specified, defaults will be used (svgLength: 2, svgHeight: 2)
type FileSvgOptions = {
  svgLength?: number;
  svgHeight?: number;
  lockAspectRatio?: boolean;
  flipped?: boolean;
  threeD?: ReturnType<typeof createPrimitiveSymbol3DMetadata>;
};

const withPrimitive3D = <T extends FileSvgOptions>(
  libraryKey: string,
  options: T,
): T => ({
  ...options,
  threeD: createPrimitiveSymbol3DMetadata(
    libraryKey,
    options.svgLength,
    options.svgHeight,
  ),
});

const withPrimitivePolygon3D = <T extends Record<string, any>>(
  libraryKey: string,
  options: T,
): T => ({
  ...options,
  libraryKey,
  threeD: createPrimitiveSymbol3DMetadata(
    libraryKey,
    options.polygonWidth,
    options.polygonHeight,
  ),
});

const FILE_SVG_OPTIONS: Record<string, FileSvgOptions> = {
  // ELEVATION/WALL ATTACHMENTS
  "ELEVATION/WALL ATTACHMENTS/Door.svg": { svgLength: 0.9, svgHeight: 2.1, flipped: false },
  "ELEVATION/WALL ATTACHMENTS/Door2.svg": { svgLength: 0.9, svgHeight: 2.1, flipped: false },
  "ELEVATION/WALL ATTACHMENTS/Window.svg": { svgLength: 0.89, svgHeight: 1.200, flipped: false },
  "ELEVATION/WALL ATTACHMENTS/Window2.svg": { svgLength: 0.892, svgHeight: 1.200, flipped: false },
  "ELEVATION/WALL ATTACHMENTS/Window3.svg": { svgLength: 0.864, svgHeight: 1.200, flipped: false },
  "ELEVATION/WALL ATTACHMENTS/Window4.svg": { svgLength: 0.697, svgHeight: 1.200, flipped: false },
  "ELEVATION/WALL ATTACHMENTS/Window5.svg": { svgLength: 1.05, svgHeight: 1.200, flipped: false },
  "ELEVATION/WALL ATTACHMENTS/Window6.svg": { svgLength: 0.796, svgHeight: 1.600, flipped: false },
  
  // ELEVATION/BATHROOM
  "ELEVATION/BATHROOM/Mirror round.svg": { svgLength: 0.5, svgHeight: 0.5, flipped: false },
  "ELEVATION/BATHROOM/Mirror.svg": { svgLength: 0.4, svgHeight: 0.523, flipped: false },
  "ELEVATION/BATHROOM/Sink.svg": { svgLength: 0.5, svgHeight: 0.296, flipped: false },
  "ELEVATION/BATHROOM/Sink2.svg": { svgLength: 0.45, svgHeight: 0.462, flipped: false },
  "ELEVATION/BATHROOM/Sink3.svg": { svgLength: 0.45, svgHeight: 0.216, flipped: false },
  "ELEVATION/BATHROOM/Toilet 2.svg": { svgLength: 0.6, svgHeight: 0.690, flipped: false },
  "ELEVATION/BATHROOM/Toilet.svg": { svgLength: 0.4, svgHeight: 0.619, flipped: false },
  "ELEVATION/BATHROOM/Washing machine.svg": { svgLength: 0.6, svgHeight: 0.667, flipped: false },

  // ELEVATION/BOTANICALS
  "ELEVATION/BOTANICALS/Bush.svg": { svgLength: 0.8, svgHeight: 0.560, flipped: false },
  "ELEVATION/BOTANICALS/Plant.svg": { svgLength: 0.67, svgHeight: 1.230, flipped: false },
  "ELEVATION/BOTANICALS/Plant2.svg": { svgLength: 0.18, svgHeight: 0.346, flipped: false },
  "ELEVATION/BOTANICALS/Tree.svg": { svgLength: 2.68, svgHeight: 3, flipped: false },
  "ELEVATION/BOTANICALS/Tree3.svg": { svgLength: 1.326, svgHeight: 1.999, flipped: false },
  "ELEVATION/BOTANICALS/Tree4.svg": { svgLength: 3.357, svgHeight: 4.500, flipped: false },
  "ELEVATION/BOTANICALS/Tree5.svg": { svgLength: 2.323, svgHeight: 4.001, flipped: false },

  // ELEVATION/DINING AREA
  "ELEVATION/DINING AREA/Chair.svg": { svgLength: 0.5, svgHeight: 0.814, flipped: false },
  "ELEVATION/DINING AREA/Chair3.svg": { svgLength: 0.493, svgHeight: 0.815, flipped: false },
  "ELEVATION/DINING AREA/Table.svg": { svgLength: 1.053, svgHeight: 0.740, flipped: false },
  "ELEVATION/DINING AREA/Table2.svg": { svgLength: 1.44, svgHeight: 0.740, flipped: false },
  "ELEVATION/DINING AREA/Table3.svg": { svgLength: 0.867, svgHeight: 0.740, flipped: false },

  // ELEVATION/KITCHEN
  "ELEVATION/KITCHEN/Cabinet corner.svg": { svgLength: 1.1, svgHeight: 0.865, flipped: false },
  "ELEVATION/KITCHEN/Cabinet side.svg": { svgLength: 0.515, svgHeight: 0.865, flipped: false },
  "ELEVATION/KITCHEN/Cabinet.svg": { svgLength: 0.865, svgHeight: 0.865, flipped: false },
  "ELEVATION/KITCHEN/Cabinet2.svg": { svgLength: 0.6, svgHeight: 0.865, flipped: false },
  "ELEVATION/KITCHEN/Cabinet3.svg": { svgLength: 1.2, svgHeight: 0.865, flipped: false },
  "ELEVATION/KITCHEN/Cabinet4.svg": { svgLength: 1.8, svgHeight: 0.865, flipped: false },
  "ELEVATION/KITCHEN/Drawer.svg": { svgLength: 0.6, svgHeight: 0.865, flipped: false },
  "ELEVATION/KITCHEN/Fridge.svg": { svgLength: 1.08, svgHeight: 1.850, flipped: false },
  "ELEVATION/KITCHEN/Fridge2.svg": { svgLength: 1.08, svgHeight: 1.850, flipped: false },
  "ELEVATION/KITCHEN/Fridge3.svg": { svgLength: 0.6, svgHeight: 1.350, flipped: false },
  "ELEVATION/KITCHEN/Microwave.svg": { svgLength: 0.5, svgHeight: 0.278, flipped: false },
  "ELEVATION/KITCHEN/Oven.svg": { svgLength: 0.6, svgHeight: 0.720, flipped: false },
  "ELEVATION/KITCHEN/Stove_ Dishwasher.svg": { svgLength: 0.6, svgHeight: 0.6, flipped: false },
  "ELEVATION/KITCHEN/Stove.svg": { svgLength: 0.6, svgHeight: 0.6, flipped: false },

  // ELEVATION/LIGHTING
  "ELEVATION/LIGHTING/Ceiling Lamp 2.svg": { svgLength: 0.9, svgHeight: 0.844, flipped: false },
  "ELEVATION/LIGHTING/Ceiling Lamp.svg": { svgLength: 0.9, svgHeight: 0.965, flipped: false },
  "ELEVATION/LIGHTING/Ceiling Lamp3.svg": { svgLength: 0.3, svgHeight: 0.736, flipped: false },
  "ELEVATION/LIGHTING/Floor lamp.svg": { svgLength: 0.717, svgHeight: 1.600, flipped: false },
  "ELEVATION/LIGHTING/Table Lamp 2.svg": { svgLength: 0.3, svgHeight: 0.344, flipped: false },
  "ELEVATION/LIGHTING/Table Lamp.svg": { svgLength: 0.3, svgHeight: 0.358, flipped: false },
  "ELEVATION/LIGHTING/Table Lamp3.svg": { svgLength: 0.3, svgHeight: 0.266, flipped: false },

  // ELEVATION/LIVING ROOM
  "ELEVATION/LIVING ROOM/2 seat sofa 2.svg": { svgLength: 1.9, svgHeight: 0.794, flipped: false },
  "ELEVATION/LIVING ROOM/2 seat sofa.svg": { svgLength: 1.9, svgHeight: 0.867, flipped: false },
  "ELEVATION/LIVING ROOM/3 seater sofa.svg": { svgLength: 2.5, svgHeight: 0.885, flipped: false },
  "ELEVATION/LIVING ROOM/Cabinet.svg": { svgLength: 0.9, svgHeight: 0.9, flipped: false },
  "ELEVATION/LIVING ROOM/Cabinet2.svg": { svgLength: 0.9, svgHeight: 0.9, flipped: false },
  "ELEVATION/LIVING ROOM/Chair.svg": { svgLength: 0.5, svgHeight: 0.814, flipped: false },
  "ELEVATION/LIVING ROOM/Chair3.svg": { svgLength: 0.493, svgHeight: 0.815, flipped: false },
  "ELEVATION/LIVING ROOM/Couch.svg": { svgLength: 1, svgHeight: 0.890, flipped: false },
  "ELEVATION/LIVING ROOM/Lounge chair 2.svg": { svgLength: 1.1, svgHeight: 0.984, flipped: false },
  "ELEVATION/LIVING ROOM/Lounge Chair.svg": { svgLength: 1.141, svgHeight: 1, flipped: false },
  "ELEVATION/LIVING ROOM/Lounge chair3.svg": { svgLength: 1.8, svgHeight: 1.211, flipped: false },

  // ELEVATION/OFFICE (note the space in directory name)
  "ELEVATION/OFFICE /Desk.svg": { svgLength: 0.7, svgHeight: 0.745, flipped: false },
  "ELEVATION/OFFICE /Desk2.svg": { svgLength: 0.7, svgHeight: 0.745, flipped: false },
  "ELEVATION/OFFICE /Office chair2.svg": { svgLength: 0.76, svgHeight: 1.113, flipped: false },
  "ELEVATION/OFFICE /Office Chair3.svg": { svgLength: 0.745, svgHeight: 1.182, flipped: false },

  // FLOOR_PLAN/KITCHEN
  "FLOOR_PLAN/KITCHEN/Sink.svg": withPrimitive3D("FLOOR_PLAN/KITCHEN/Sink", { svgLength: 0.939, svgHeight: 0.500, flipped: false }),
  "FLOOR_PLAN/KITCHEN/Stove.svg": withPrimitive3D("FLOOR_PLAN/KITCHEN/Stove", { svgLength: 0.904, svgHeight: 0.600, flipped: false }),
  "FLOOR_PLAN/KITCHEN/Stove3.svg": withPrimitive3D("FLOOR_PLAN/KITCHEN/Stove3", { svgLength: 0.599, svgHeight: 0.6, flipped: false }),
  "FLOOR_PLAN/KITCHEN/Cabinet5.svg": withPrimitive3D("FLOOR_PLAN/KITCHEN/Cabinet5", { svgLength: 0.599, svgHeight: 0.6, flipped: false }),
  "FLOOR_PLAN/KITCHEN/Sink4.svg": withPrimitive3D("FLOOR_PLAN/KITCHEN/Sink4", { svgLength: 0.884, svgHeight: 0.5, flipped: false }),
  "FLOOR_PLAN/KITCHEN/Sink5.svg": withPrimitive3D("FLOOR_PLAN/KITCHEN/Sink5", { svgLength: 0.573, svgHeight: 0.5, flipped: false }),
  "FLOOR_PLAN/KITCHEN/Fridge5.svg": withPrimitive3D("FLOOR_PLAN/KITCHEN/Fridge5", { svgLength: 0.599, svgHeight: 0.6, flipped: false }),
  "FLOOR_PLAN/KITCHEN/Fridge4.svg": withPrimitive3D("FLOOR_PLAN/KITCHEN/Fridge4", { svgLength: 0.6, svgHeight: 0.6, flipped: false }),
  "FLOOR_PLAN/KITCHEN/Stove4.svg": withPrimitive3D("FLOOR_PLAN/KITCHEN/Stove4", { svgLength: 0.6, svgHeight: 0.6, flipped: false }),
  "FLOOR_PLAN/KITCHEN/Stove5.svg": withPrimitive3D("FLOOR_PLAN/KITCHEN/Stove5", { svgLength: 0.6, svgHeight: 0.6, flipped: false }),

  // FLOOR_PLAN/LIVING ROOM
  "FLOOR_PLAN/LIVING ROOM/Screen.svg": withPrimitive3D("FLOOR_PLAN/LIVING ROOM/Screen", { svgLength: 1, svgHeight: 0.170, flipped: false }),
  "FLOOR_PLAN/LIVING ROOM/Screen2.svg": withPrimitive3D("FLOOR_PLAN/LIVING ROOM/Screen2", { svgLength: 1.5, svgHeight: 0.162, flipped: false }),

  // FLOOR_PLAN/OFFICE
  "FLOOR_PLAN/OFFICE/Screen3.svg": withPrimitive3D("FLOOR_PLAN/OFFICE/Screen3", { svgLength: 1, svgHeight: 0.170, flipped: false }),
  "FLOOR_PLAN/OFFICE/Screen4.svg": withPrimitive3D("FLOOR_PLAN/OFFICE/Screen4", { svgLength: 1.5, svgHeight: 0.162, flipped: false }),

  // FLOOR_PLAN/BOTANICALS
  "FLOOR_PLAN/BOTANICALS/Bush7.svg": withPrimitive3D("FLOOR_PLAN/BOTANICALS/Bush7", { svgLength: 0.9, svgHeight: 0.869, flipped: false }),
  "FLOOR_PLAN/BOTANICALS/Bush8.svg": withPrimitive3D("FLOOR_PLAN/BOTANICALS/Bush8", { svgLength: 2.507, svgHeight: 0.9, flipped: false }),
  "FLOOR_PLAN/BOTANICALS/Bush9.svg": withPrimitive3D("FLOOR_PLAN/BOTANICALS/Bush9", { svgLength: 1.3, svgHeight: 1.186, flipped: false }),
  "FLOOR_PLAN/BOTANICALS/Bush10.svg": { svgLength: 0.9, svgHeight: 0.917, flipped: false },
  "FLOOR_PLAN/BOTANICALS/Tree10.svg": withPrimitive3D("FLOOR_PLAN/BOTANICALS/Tree10", { svgLength: 2.8, svgHeight: 3.406, flipped: false }),
  "FLOOR_PLAN/BOTANICALS/Tree11.svg": withPrimitive3D("FLOOR_PLAN/BOTANICALS/Tree11", { svgLength: 2.600, svgHeight: 2.584, flipped: false }),

  // FLOOR_PLAN/SYMBOLS & SIGNS
  "FLOOR_PLAN/SYMBOLS & SIGNS/Bonnie.svg": withPrimitive3D("FLOOR_PLAN/SYMBOLS & SIGNS/Bonnie", { svgLength: 0.5, svgHeight: 0.3, flipped: false }),
  "FLOOR_PLAN/SYMBOLS & SIGNS/Lighting.svg": withPrimitive3D("FLOOR_PLAN/SYMBOLS & SIGNS/Lighting", { svgLength: 0.643, svgHeight: 0.2, flipped: false }),
  "FLOOR_PLAN/SYMBOLS & SIGNS/Ungrounded power outlet.svg": withPrimitive3D("FLOOR_PLAN/SYMBOLS & SIGNS/Ungrounded power outlet", { svgLength: 0.209, svgHeight: 0.2, flipped: false }),
  "FLOOR_PLAN/SYMBOLS & SIGNS/Grounded power outlet.svg": { svgLength: 0.259, svgHeight: 0.2, flipped: false },
  "FLOOR_PLAN/SYMBOLS & SIGNS/North.svg": { svgLength: 0.723, svgHeight: 0.9, flipped: false },
  "FLOOR_PLAN/SYMBOLS & SIGNS/Curtain.svg": withPrimitive3D("FLOOR_PLAN/SYMBOLS & SIGNS/Curtain", { svgLength: 1, svgHeight: 0.064, flipped: false }),
};

const toTitleCase = (value: string) =>
  value
    .replace(/_/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());

const ASSET_ORDER_BY_CATEGORY: Record<string, readonly string[]> = {
  "Dining Area": [
    "MANUAL/smart-rectangular-table",
    "MANUAL/smart-round-table",
    "MANUAL/plain-round-table",
    "MANUAL/plain-table",
    "MANUAL/armchair-dining",
    "MANUAL/chair",
    "MANUAL/2-chair-table",
    "MANUAL/4-chair-table",
    "MANUAL/6-chair-table",
    "MANUAL/round-table",
  ],
};

const buildLibrary = (): SymbolLibrary => {
  const library: SymbolLibrary = {};

  symbolsContext.keys().forEach((key) => {
    const resourcePath = key.startsWith("./") ? key.slice(2) : key;
    const parts = resourcePath.split("/");
    if (parts.length < 3) {
      return;
    }

    const [tab, category, ...rest] = parts;
    const fileName = rest.join("/");
    if (!fileName.toLowerCase().endsWith(".svg")) {
      return;
    }

    // Only process SVG files for valid tabs (FLOOR_PLAN and ELEVATION)
    if (tab !== "FLOOR_PLAN" && tab !== "ELEVATION") {
      return;
    }

    const label = fileName.slice(0, -4);

    // Look up custom SVG options for this file using full path
    const fullPath = `${tab}/${category}/${fileName}`;
    const fileOptions = FILE_SVG_OPTIONS[fullPath];
    const svgOptions = {
      svgPath: symbolsContext<string>(key),
      svgLength: fileOptions?.svgLength || 2,
      svgHeight: fileOptions?.svgHeight || 2,
      lockAspectRatio:
        fileOptions?.lockAspectRatio !== undefined
          ? fileOptions.lockAspectRatio
          : true,
      threeD: fileOptions?.threeD,
      name: label,
    };

    // Normalize category names to title case for consistent ordering
    const normalizedCategory = toTitleCase(category);

    const asset: LibrarySymbolAsset = {
      id: `${tab}/${category}/${label}`,
      tab,
      category: normalizedCategory,
      label,
      fileName,
      src: symbolsContext<string>(key),
      legacyType: "SvgSymbol",
      svgOptions,
      scaleReliable: Boolean(fileOptions?.svgLength && fileOptions?.svgHeight),
    };

    if (!library[tab]) {
      library[tab] = {};
    }
    if (!library[tab][normalizedCategory]) {
      library[tab][normalizedCategory] = [];
    }
    library[tab][normalizedCategory].push(asset);
    
  });

  const manualEntries: Array<{ category: string; asset: LibrarySymbolAsset }> = [
    // Wall attachments
    {
      category: "Wall Attachments",
      asset: {
        id: "MANUAL/Door",
        tab: "MANUAL",
        category: "Wall Attachments",
        label: "Single door",
        fileName: "manual",
        src: singleDoorPreview,
        legacyType: "Door",
      },
    },
    {
      category: "Wall Attachments",
      asset: {
        id: "MANUAL/SlidingDoor",
        tab: "MANUAL",
        category: "Wall Attachments",
        label: "Sliding door",
        fileName: "manual",
        src: slidingDoorPreview,
        legacyType: "SlidingDoor",
      },
    },
    {
      category: "Wall Attachments",
      asset: {
        id: "MANUAL/GlassSlidingDoor",
        tab: "MANUAL",
        category: "Wall Attachments",
        label: "Glass sliding door",
        fileName: "manual",
        src: slidingDoorPreview,
        legacyType: "GlassSlidingDoor",
      },
    },
    {
      category: "Wall Attachments",
      asset: {
        id: "MANUAL/DoubleDoor",
        tab: "MANUAL",
        category: "Wall Attachments",
        label: "Double door",
        fileName: "manual",
        src: doubleDoorPreview,
        legacyType: "DoubleDoor",
      },
    },
    {
      category: "Wall Attachments",
      asset: {
        id: "MANUAL/Window",
        tab: "MANUAL",
        category: "Wall Attachments",
        label: "Window",
        fileName: "manual",
        src: windowPreview,
        legacyType: "Window",
      },
    },
    {
      category: "Wall Attachments",
      asset: {
        id: "MANUAL/void-symbol",
        tab: "MANUAL",
        category: "Wall Attachments",
        label: "Void",
        fileName: "manual",
        src: voidPreview,
        legacyType: "Void",
      },
    },
    // Stairs
    {
      category: "Stairs",
      asset: {
        id: "MANUAL/CircleStairs",
        tab: "MANUAL",
        category: "Stairs",
        label: "Circular stairs",
        fileName: "manual",
        src: circleStairPreview,
        legacyType: "CircleStairs",
      },
    },
    {
      category: "Stairs",
      asset: {
        id: "MANUAL/RectStairs",
        tab: "MANUAL",
        category: "Stairs",
        label: "Rectangular stairs",
        fileName: "manual",
        src: rectangulrStairPreview,
        legacyType: "RectStairs",
      },
    },
    {
      category: "Stairs",
      asset: {
        id: "MANUAL/TurnStairs",
        tab: "MANUAL",
        category: "Stairs",
        label: "Turn stairs",
        fileName: "manual",
        src: "",
        Icon: TurnStairsIcon,
        legacyType: "TurnStairs",
      },
    },
    // Living Room furniture
    {
      category: "Living Room",
      asset: {
        id: BOOK_SHELF_LIBRARY_KEY,
        tab: "MANUAL",
        category: "Living Room",
        label: "Bookshelf",
        fileName: "manual",
        src: BookShelfIcon,
        legacyType: "BookShelfSymbol",
        svgOptions: {
          name: "Bookshelf",
          bookShelf: createDefaultBookShelfConfig(),
          threeD: createBookShelf3DMetadata(),
        },
      },
    },
    {
      category: "Living Room",
      asset: {
        id: "MANUAL/Lounge-2-seat-sofa",
        tab: "MANUAL",
        category: "Living Room",
        label: "2 seat sofa",
        fileName: "manual",
        src: twoSeatSofaPreview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: Sofa2seatIcon,
          svgLength: 1.5,
          svgHeight: 0.853,
          name: "2 seat sofa",
        },
      },
    },
    {
      category: "Living Room",
      asset: {
        id: "MANUAL/Lounge-3-seat-sofa",
        tab: "MANUAL",
        category: "Living Room",
        label: "3 seat sofa",
        fileName: "manual",
        src: threeSeatSofaPreview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: Sofa3seatIcon,
          svgLength: 2,
          svgHeight: 0.857,
          name: "3 seat sofa",
        },
      },
    },
    {
      category: "Living Room",
      asset: {
        id: "MANUAL/Modular-sofa",
        tab: "MANUAL",
        category: "Living Room",
        label: "Modular sofa",
        fileName: "manual",
        src: modularSofaPreview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: ModularSofaIcon,
          svgLength: 2.4,
          svgHeight: 2.136,
          name: "Modular sofa",
        },
      },
    },
    {
      category: "Living Room",
      asset: {
        id: "MANUAL/Chaise-sofa",
        tab: "MANUAL",
        category: "Living Room",
        label: "Chaise sofa",
        fileName: "manual",
        src: chaiseSofaPreview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: ChaiseSofaIcon,
          svgLength: 1.8,
          svgHeight: 0.867,
          name: "Chaise sofa",
        },
      },
    },
    {
      category: "Living Room",
      asset: {
        id: "MANUAL/Lounge-chair-1",
        tab: "MANUAL",
        category: "Living Room",
        label: "Lounge chair",
        fileName: "manual",
        src: loungeChair1Preview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: LoungeChair1Icon,
          svgLength: 0.801,
          svgHeight: 0.743,
          name: "Lounge chair",
        },
      },
    },
    {
      category: "Living Room",
      asset: {
        id: "MANUAL/Lounge-chair-2",
        tab: "MANUAL",
        category: "Living Room",
        label: "Lounge chair",
        fileName: "manual",
        src: loungeChair2Preview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: LoungeChair2Icon,
          svgLength: 0.699,
          svgHeight: 0.703,
          name: "Lounge chair",
        },
      },
    },
    {
      category: "Living Room",
      asset: {
        id: "MANUAL/Armchair",
        tab: "MANUAL",
        category: "Living Room",
        label: "Armchair",
        fileName: "manual",
        src: armChair1Preview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: ArmChairIcon,
          svgLength: 0.6,
          svgHeight: 0.614,
          name: "Armchair",
        },
      },
    },
    {
      category: "Living Room",
      asset: {
        id: "MANUAL/Octagonal-coffee-table",
        tab: "MANUAL",
        category: "Living Room",
        label: "Octagonal coffee table",
        fileName: "manual",
        src: octagonalPreview,
        legacyType: "PolygonSymbol",
        svgOptions: withPrimitivePolygon3D("MANUAL/Octagonal-coffee-table", {
          polygonKind: "octagon",
          polygonSides: 8,
          polygonWidth: 0.9,
          polygonHeight: 0.884,
          name: "Octagonal coffee table",
        }),
      },
    },
    {
      category: "Living Room",
      asset: {
        id: "MANUAL/Pentagonal-coffee-table",
        tab: "MANUAL",
        category: "Living Room",
        label: "Pentagonal coffee table",
        fileName: "manual",
        src: pentagonalPreview,
        legacyType: "PolygonSymbol",
        svgOptions: withPrimitivePolygon3D("MANUAL/Pentagonal-coffee-table", {
          polygonKind: "pentagon",
          polygonSides: 5,
          polygonWidth: 0.946,
          polygonHeight: 0.939,
          name: "Pentagonal coffee table",
        }),
      },
    },
    {
      category: "Living Room",
      asset: {
        id: "MANUAL/Hexagonal-coffee-table",
        tab: "MANUAL",
        category: "Living Room",
        label: "Hexagonal coffee table",
        fileName: "manual",
        src: hexagonalPreview,
        legacyType: "PolygonSymbol",
        svgOptions: withPrimitivePolygon3D("MANUAL/Hexagonal-coffee-table", {
          polygonKind: "hexagon",
          polygonSides: 6,
          polygonWidth: 1.039,
          polygonHeight: 0.906,
          name: "Hexagonal coffee table",
        }),
      },
    },
    {
      category: "Living Room",
      asset: {
        id: "MANUAL/Oval-coffee-table",
        tab: "MANUAL",
        category: "Living Room",
        label: "Coffee table 1",
        fileName: "manual",
        src: coffeeTable1Preview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: OrganicCoffTabIcon,
          svgLength: 1.092,
          svgHeight: 0.771,
          flipped: true,
          name: "Coffee table 1",
        },
      },
    },
    {
      category: "Living Room",
      asset: {
        id: "MANUAL/Oval-coffee-table-2",
        tab: "MANUAL",
        category: "Living Room",
        label: "Coffee table 2",
        fileName: "manual",
        src: coffeeTable2Preview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: OvalCoffTabIcon,
          svgLength: 1.2,
          svgHeight: 0.485,
          name: "Coffee table 2",
        },
      },
    },
    // Dining Area
    {
      category: "Dining Area",
      asset: {
        id: "MANUAL/smart-rectangular-table",
        tab: "MANUAL",
        category: "Dining Area",
        label: "Smart rectangular table",
        fileName: "manual",
        src: Chair4TableIcon,
        legacyType: "SmartTableSymbol",
        svgOptions: {
          name: "Smart rectangular table",
          smartTable: createDefaultSmartRectangleTableConfig(),
          threeD: createSmartTable3DMetadata("rectangle"),
        },
      },
    },
    {
      category: "Dining Area",
      asset: {
        id: "MANUAL/smart-round-table",
        tab: "MANUAL",
        category: "Dining Area",
        label: "Smart round table",
        fileName: "manual",
        src: RoundTableIcon,
        legacyType: "SmartTableSymbol",
        svgOptions: {
          name: "Smart round table",
          smartTable: createDefaultSmartRoundTableConfig(),
          threeD: createSmartTable3DMetadata("round"),
        },
      },
    },
    {
      category: "Dining Area",
      asset: {
        id: "MANUAL/plain-table",
        tab: "MANUAL",
        category: "Dining Area",
        label: "Plain table",
        fileName: "manual",
        src: PlainTableIcon,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: PlainTableIcon,
          svgLength:
            DINING_SYMBOL_LIBRARY_DIMENSIONS["MANUAL/plain-table"].symLength,
          svgHeight:
            DINING_SYMBOL_LIBRARY_DIMENSIONS["MANUAL/plain-table"].symHeight,
          name: "Plain table",
        },
      },
    },
    {
      category: "Dining Area",
      asset: {
        id: "MANUAL/plain-round-table",
        tab: "MANUAL",
        category: "Dining Area",
        label: "Plain round table",
        fileName: "manual",
        src: PlainRoundTableIcon,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: PlainRoundTableIcon,
          svgLength:
            DINING_SYMBOL_LIBRARY_DIMENSIONS["MANUAL/plain-round-table"]
              .symLength,
          svgHeight:
            DINING_SYMBOL_LIBRARY_DIMENSIONS["MANUAL/plain-round-table"]
              .symHeight,
          name: "Plain round table",
        },
      },
    },
    {
      category: "Dining Area",
      asset: {
        id: "MANUAL/6-chair-table",
        tab: "MANUAL",
        category: "Dining Area",
        label: "6 chair table",
        fileName: "manual",
        src: Chair6TableIcon,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: Chair6TableIcon,
          svgLength:
            DINING_SYMBOL_LIBRARY_DIMENSIONS["MANUAL/6-chair-table"].symLength,
          svgHeight:
            DINING_SYMBOL_LIBRARY_DIMENSIONS["MANUAL/6-chair-table"].symHeight,
          name: "6 chair table",
        },
      },
    },
    {
      category: "Dining Area",
      asset: {
        id: "MANUAL/4-chair-table",
        tab: "MANUAL",
        category: "Dining Area",
        label: "4 chair table",
        fileName: "manual",
        src: Chair4TableIcon,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: Chair4TableIcon,
          svgLength:
            DINING_SYMBOL_LIBRARY_DIMENSIONS["MANUAL/4-chair-table"].symLength,
          svgHeight:
            DINING_SYMBOL_LIBRARY_DIMENSIONS["MANUAL/4-chair-table"].symHeight,
          name: "4 chair table",
        },
      },
    },
    {
      category: "Dining Area",
      asset: {
        id: "MANUAL/2-chair-table",
        tab: "MANUAL",
        category: "Dining Area",
        label: "2 chair table",
        fileName: "manual",
        src: Chair2TableIcon,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: Chair2TableIcon,
          svgLength:
            DINING_SYMBOL_LIBRARY_DIMENSIONS["MANUAL/2-chair-table"].symLength,
          svgHeight:
            DINING_SYMBOL_LIBRARY_DIMENSIONS["MANUAL/2-chair-table"].symHeight,
          name: "2 chair table",
        },
      },
    },
    {
      category: "Dining Area",
      asset: {
        id: "MANUAL/round-table",
        tab: "MANUAL",
        category: "Dining Area",
        label: "Round table",
        fileName: "manual",
        src: RoundTableIcon,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: RoundTableIcon,
          svgLength:
            DINING_SYMBOL_LIBRARY_DIMENSIONS["MANUAL/round-table"].symLength,
          svgHeight:
            DINING_SYMBOL_LIBRARY_DIMENSIONS["MANUAL/round-table"].symHeight,
          name: "Round table",
        },
      },
    },
    {
      category: "Dining Area",
      asset: {
        id: "MANUAL/chair",
        tab: "MANUAL",
        category: "Dining Area",
        label: "Chair",
        fileName: "manual",
        src: chairPreview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: ChairSVG,
          svgLength: 0.5,
          svgHeight: 0.45,
          name: "Chair",
        },
      },
    },
    {
      category: "Dining Area",
      asset: {
        id: "MANUAL/armchair-dining",
        tab: "MANUAL",
        category: "Dining Area",
        label: "Armchair",
        fileName: "manual",
        src: armChair2Preview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: ArmChairDRIcon,
          svgLength: DINING_ARMCHAIR_SIZE_M,
          svgHeight: DINING_ARMCHAIR_SIZE_M,
          name: "Armchair",
        },
      },
    },
    // Kitchen
    {
      category: "Kitchen",
      asset: {
        id: "MANUAL/dishwasher",
        tab: "MANUAL",
        category: "Kitchen",
        label: "Dishwasher",
        fileName: "manual",
        src: DishWasherIcon,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: DishWasherIcon,
          svgLength: 0.6,
          svgHeight: 0.6,
          name: "Dishwasher",
        },
      },
    },
    // Bathroom
    {
      category: "Bathroom",
      asset: {
        id: "MANUAL/basin",
        tab: "MANUAL",
        category: "Bathroom",
        label: "Basin",
        fileName: "manual",
        src: basinPreview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: BasinIcon,
          svgLength: 0.6,
          svgHeight: 0.450,
          name: "Basin",
        },
      },
    },
    {
      category: "Bathroom",
      asset: {
        id: "MANUAL/bathtub",
        tab: "MANUAL",
        category: "Bathroom",
        label: "Bathtub",
        fileName: "manual",
        src: bathtubPreview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: BathtubIcon,
          svgLength: 1.828,
          svgHeight: 0.800,
          name: "Bathtub",
        },
      },
    },
    {
      category: "Bathroom",
      asset: {
        id: "MANUAL/toilet",
        tab: "MANUAL",
        category: "Bathroom",
        label: "Toilet",
        fileName: "manual",
        src: toiletPreview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: ToiletIcon,
          svgLength: 0.65,
          svgHeight: 0.35,
          name: "Toilet",
        },
      },
    },
    {
      category: "Bathroom",
      asset: {
        id: "MANUAL/shower",
        tab: "MANUAL",
        category: "Bathroom",
        label: "Shower",
        fileName: "manual",
        src: showerPreview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: ShowerIcon,
          svgLength: 0.9,
          svgHeight: 0.9,
          name: "Shower",
        },
      },
    },
    // Bedroom
    {
      category: "Bedroom",
      asset: {
        id: "MANUAL/king-bed",
        tab: "MANUAL",
        category: "Bedroom",
        label: "King bed",
        fileName: "manual",
        src: kingBedPreview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: KingBedIcon,
          svgLength: 2.1,
          svgHeight: 1.800,
          name: "King bed",
        },
      },
    },
    {
      category: "Bedroom",
      asset: {
        id: "MANUAL/single-bed",
        tab: "MANUAL",
        category: "Bedroom",
        label: "Single bed",
        fileName: "manual",
        src: singleBedPreview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: SingleBedIcon,
          svgLength: 2.1,
          svgHeight: 0.900,
          name: "Single bed",
        },
      },
    },
    // Botanicals
    {
      category: "Botanicals",
      asset: {
        id: "MANUAL/plant",
        tab: "MANUAL",
        category: "Botanicals",
        label: "Plant",
        fileName: "manual",
        src: plantPreview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: PlantSymbol,
          svgLength: 0.712,
          svgHeight: 0.7,
          name: "Plant",
        },
      },
    },
    // {
    //   category: "Symbols & Signs",
    //   asset: {
    //     id: "MANUAL/curtain-1",
    //     tab: "MANUAL",
    //     category: "Symbols & Signs",
    //     label: "Curtain 1",
    //     fileName: "manual",
    //     src: curtain1Preview,
    //     legacyType: "SvgSymbol",
    //     svgOptions: {
    //       svgPath: Curtain1Icon,
    //       svgLength: 1,
    //       svgHeight: 0.2,
    //    //       name: "Curtain",
    //     },
    //   },
    // },
    // {
    //   category: "Symbols & Signs",
    //   asset: {
    //     id: "MANUAL/curtain-2",
    //     tab: "MANUAL",
    //     category: "Symbols & Signs",
    //     label: "Curtain 2",
    //     fileName: "manual",
    //     src: curtain2Preview,
    //     legacyType: "SvgSymbol",
    //     svgOptions: {
    //       svgPath: Curtain2Icon,
    //       svgLength: 1,
    //       svgHeight: 0.1,
    //    //       name: "Curtain",
    //     },
    //   },
    // },
    {
      category: "Symbols & Signs",
      asset: {
        id: "MANUAL/hangers-1",
        tab: "MANUAL",
        category: "Symbols & Signs",
        label: "Hangers 1",
        fileName: "manual",
        src: hanger1Preview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: Hanger1Icon,
          svgLength: 0.782,
          svgHeight: 0.600,
          name: "Hangers",
        },
      },
    },
    {
      category: "Symbols & Signs",
      asset: {
        id: "MANUAL/hangers-2",
        tab: "MANUAL",
        category: "Symbols & Signs",
        label: "Hangers 2",
        fileName: "manual",
        src: hanger2Preview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: Hanger2Icon,
          svgLength: 1.044,
          svgHeight: 0.600,
          name: "Hangers",
        },
      },
    },
    {
      category: "Symbols & Signs",
      asset: {
        id: "MANUAL/hangers-3",
        tab: "MANUAL",
        category: "Symbols & Signs",
        label: "Hangers 3",
        fileName: "manual",
        src: hanger3Preview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: Hanger3Icon,
          svgLength: 1.304,
          svgHeight: 0.600,
          name: "Hangers",
        },
      },
    },
    {
      category: "Symbols & Signs",
      asset: {
        id: "MANUAL/hangers-4",
        tab: "MANUAL",
        category: "Symbols & Signs",
        label: "Hangers 4",
        fileName: "manual",
        src: hanger4Preview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: Hanger4Icon,
          svgLength: 1.566,
          svgHeight: 0.600,
          name: "Hangers",
        },
      },
    },
    // Symbols & Signs
    {
      category: "Symbols & Signs",
      asset: {
        id: "MANUAL/spotlight",
        tab: "MANUAL",
        category: "Symbols & Signs",
        label: "Spotlight",
        fileName: "manual",
        src: spotlightPreview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: SpotlightIcon,
          svgLength: 0.2,
          svgHeight: 0.2,
          name: "Spotlight",
        },
      },
    },
    {
      category: "Symbols & Signs",
      asset: {
        id: "MANUAL/lighting-fixture",
        tab: "MANUAL",
        category: "Symbols & Signs",
        label: "Lighting fixture",
        fileName: "manual",
        src: lightingFixturePreview,
        legacyType: "SvgSymbol",
        svgOptions: {
          svgPath: LightFixIcon,
          svgLength: 0.2,
          svgHeight: 0.2,
          name: "Lighting fixture",
          lineWeight: 1.5,
        },
      },
    },
  ];

  // Add manual entries to FLOOR_PLAN tab
  const FLOOR_PLAN_TAB = "FLOOR_PLAN";
  if (!library[FLOOR_PLAN_TAB]) {
    library[FLOOR_PLAN_TAB] = {};
  }

  manualEntries.forEach(({ category, asset }) => {
    if (MANUAL_LABEL_KEYS[asset.id]) {
      asset.labelKey = MANUAL_LABEL_KEYS[asset.id];
    }
    if (asset.svgOptions && !asset.svgOptions.threeD) {
      asset.svgOptions = {
        ...asset.svgOptions,
        threeD: createPrimitiveSymbol3DMetadata(
          asset.id,
          asset.svgOptions.svgLength,
          asset.svgOptions.svgHeight,
        ),
      };
    }
    if (!library[FLOOR_PLAN_TAB][category]) {
      library[FLOOR_PLAN_TAB][category] = [];
    }
    library[FLOOR_PLAN_TAB][category].push(asset);
  });


  // Sort assets within each category
  Object.values(library).forEach((categories) => {
    Object.keys(categories).forEach((category) => {
      const assetOrder = ASSET_ORDER_BY_CATEGORY[category];
      categories[category].sort((a, b) => {
        if (assetOrder) {
          const aIndex = assetOrder.indexOf(a.id);
          const bIndex = assetOrder.indexOf(b.id);

          if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
          if (aIndex !== -1) return -1;
          if (bIndex !== -1) return 1;
        }

        return compareSymbolLibraryAssets(a, b);
      });
    });
  });

  return library;
};

const library = buildLibrary();

/** Flat list of library assets for a tab (e.g. FLOOR_PLAN furniture icons). */
export const getSymbolLibraryAssets = (
  tab: "FLOOR_PLAN" | "ELEVATION" | string,
): LibrarySymbolAsset[] => Object.values(library[tab] ?? {}).flat();

export const resolveSymbolLibraryAsset = (libraryKey: string) =>
  Object.values(library)
    .flatMap((categories) => Object.values(categories).flat())
    .find((asset) => asset.id === libraryKey);

const FLOORPLAN_IMPORT_SYMBOL_ALIASES: Record<string, string[]> = {
  [BOOK_SHELF_LIBRARY_KEY]: [
    "bookshelf",
    "book shelf",
    "bookcase",
    "shelving",
  ],
  "FLOOR_PLAN/KITCHEN/Cabinet5": [
    "kitchen cabinet",
    "base cabinet",
    "kitchen unit",
    "cupboard",
  ],
  "MANUAL/dishwasher": [
    "dishwasher",
    "dish washer",
    "diskmaskin",
  ],
  "FLOOR_PLAN/BOTANICALS/Bush7": [
    "round bush",
    "circular bush",
    "round shrub",
  ],
  "FLOOR_PLAN/BOTANICALS/Bush8": [
    "hedge",
    "rectangular bush",
    "rectangular shrub",
  ],
  "FLOOR_PLAN/BOTANICALS/Bush9": [
    "organic bush",
    "irregular bush",
    "organic shrub",
  ],
  "MANUAL/plant": ["plant", "potted plant", "indoor plant"],
  "FLOOR_PLAN/BOTANICALS/Tree10": [
    "leafy tree",
    "tree canopy",
    "deciduous tree",
  ],
  "FLOOR_PLAN/BOTANICALS/Tree11": [
    "branching tree",
    "bare tree",
    "tree branches",
  ],
};

export const getFloorplanImportSymbolCatalog = (
  tab: "FLOOR_PLAN" | "ELEVATION",
) =>
  getSymbolLibraryAssets(tab)
    .filter((asset) => asset.legacyType === "SvgSymbol")
    .map((asset) => ({
      key: asset.id,
      tab,
      category: asset.category,
      label: asset.label,
      width: Number(asset.svgOptions?.svgLength) || 1,
      height: Number(asset.svgOptions?.svgHeight) || 1,
      scaleReliable:
        asset.scaleReliable ??
        (asset.fileName === "manual" &&
          Number(asset.svgOptions?.svgLength) > 0 &&
          Number(asset.svgOptions?.svgHeight) > 0),
      aliases: Array.from(
        new Set([
          asset.label.toLowerCase(),
          asset.category.toLowerCase(),
          ...(FLOORPLAN_IMPORT_SYMBOL_ALIASES[asset.id] ?? []),
        ]),
      ),
    }));

export const getArchitectureSymbolSvgPath = (symbolKey: string) => {
  if (!symbolKey) return undefined;
  const match = resolveSymbolLibraryAsset(symbolKey);
  return match?.svgOptions?.svgPath || match?.src;
};

// Define the ordered category lists for each tab
const CATEGORY_ORDER = {
  FLOOR_PLAN: [
    "Wall Attachments",
    "Stairs", 
    "Living Room",
    "Dining Area",
    "Lighting",
    "Kitchen",
    "Bathroom",
    "Bedroom",
    "Office",
    "Botanicals",
    "Symbols & Signs"
  ],
  ELEVATION: [
    "Wall Attachments",
    "Living Room", 
    "Dining Area",
    "Lighting",
    "Kitchen",
    "Bathroom",
    "Botanicals"
  ]
};

const DEFAULT_TAB_ORDER = ["FLOOR_PLAN", "ELEVATION"];
const orderedTabs = [
  ...DEFAULT_TAB_ORDER.filter((tab) => library[tab]),
  ...Object.keys(library).filter((tab) => !DEFAULT_TAB_ORDER.includes(tab)).sort((a, b) => toTitleCase(a).localeCompare(toTitleCase(b))),
];

export const SYMBOL_LIBRARY_TABS = orderedTabs;
export const DEFAULT_SYMBOL_LIBRARY_TAB = SYMBOL_LIBRARY_TABS[0] ?? "FLOOR_PLAN";

export const formatSymbolLibraryLabel = (value: string) => toTitleCase(value);

export { isSymbolLibraryAssetDisabledIn3D, isSymbolLibraryTabDisabledIn3D };

export const SymbolLibraryTabBar: React.FC<
  Omit<SymbolLibraryTabBarProps, "tabs" | "formatTabLabel">
> = (props) => {
  const { t } = useTranslation();
  const formatTabLabel = (tab: string) => {
    const key = SYMBOL_TAB_KEYS[tab];
    return key ? t(key) : formatSymbolLibraryLabel(tab);
  };

  return (
    <SymbolLibraryTabBarControl
      {...props}
      tabs={SYMBOL_LIBRARY_TABS}
      formatTabLabel={formatTabLabel}
    />
  );
};

interface SymbolLibrarySectionsProps {
  tab: string;
  onSelect: (symbol: LibrarySymbolAsset) => void;
  className?: string;
  scrollPosition?: number;
  onScrollChange?: (position: number) => void;
  is3DView?: boolean;
  /** Case-insensitive filter against the displayed symbol label. */
  search?: string;
}

export const SymbolLibrarySections: React.FC<SymbolLibrarySectionsProps> = ({ 
  tab, 
  onSelect, 
  className, 
  scrollPosition = 0, 
  onScrollChange,
  is3DView = false,
  search = "",
}) => {
  const { t } = useTranslation();
  const scrollRef = React.useRef<HTMLDivElement>(null);

  const formatCategoryLabel = (category: string) => {
    const key = SYMBOL_CATEGORY_KEYS[category];
    return key ? t(key) : formatSymbolLibraryLabel(category);
  };

  const formatAssetLabel = (asset: LibrarySymbolAsset) =>
    asset.labelKey ? t(asset.labelKey) : formatSymbolLibraryLabel(asset.label);
  
  const categories = library[tab];
  if (!categories) {
    return null;
  }

  const searchQuery = search.trim().toLowerCase();

  // Restore scroll position when component mounts or tab changes
  React.useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollPosition;
    }
  }, [tab, scrollPosition]);

  // Track scroll position changes
  const handleScroll = React.useCallback((event: React.UIEvent<HTMLDivElement>) => {
    if (onScrollChange) {
      onScrollChange(event.currentTarget.scrollTop);
    }
  }, [onScrollChange]);

  // Sort categories according to the predefined order for each tab
  const categoryKeys = Object.keys(categories).sort((a, b) => {
    const tabOrder = CATEGORY_ORDER[tab as keyof typeof CATEGORY_ORDER];
    
    if (tabOrder) {
      const aIndex = tabOrder.indexOf(a);
      const bIndex = tabOrder.indexOf(b);
      
      // If both categories are in the predefined order, sort by their position
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }
      
      // If only one category is in the predefined order, prioritize it
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;
    }
    
    // For categories not in the predefined order, sort alphabetically
    return formatCategoryLabel(a).localeCompare(formatCategoryLabel(b));
  });

  return (
    <div 
      ref={scrollRef}
      onScroll={handleScroll}
      className={`overflow-y-auto scrollbar ${className || ''}`}
      style={{ maxHeight: 'calc(70vh - 170px)' }}
    >
      {categoryKeys.map((category) => {
        const assets = searchQuery
          ? categories[category].filter((asset) =>
              formatAssetLabel(asset).toLowerCase().includes(searchQuery),
            )
          : categories[category];
        if (!assets.length) {
          return null;
        }
        const categoryDisabled = is3DView && assets.every(isSymbolLibraryAssetDisabledIn3D);
        return (
          <div key={category} className="mb-6 px-4">
            <div className={`mb-2 text-sm font-medium ${categoryDisabled ? "text-gray-400" : ""}`}>{formatCategoryLabel(category)}</div>
            <div className="grid w-[364px] grid-cols-3 gap-2 pr-2">
              {assets.map((asset) => {
                const disabled = is3DView && isSymbolLibraryAssetDisabledIn3D(asset);
                const assetLabel = formatAssetLabel(asset);
                return (
                  <button
                    key={asset.id}
                    type="button"
                    className="group flex h-32 min-w-0 flex-col items-center justify-start overflow-hidden rounded border border-[#edebe6] bg-white p-[3px] text-left transition-shadow hover:shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-boniYellowPrimary focus-visible:ring-inset disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:shadow-none"
                    onClick={() => {
                      if (!disabled) {
                        onSelect(asset);
                      }
                    }}
                    title={disabled ? t("symbols.unavailableIn3D") : assetLabel}
                    disabled={disabled}
                  >
                    {asset.Icon ? (
                      <div
                        className="flex h-[87px] w-full shrink-0 items-center justify-center rounded-sm text-black p-2"
                        aria-hidden
                      >
                        <asset.Icon className="h-full w-full" />
                      </div>
                    ) : (
                      <img
                        className="h-[87px] w-full shrink-0 rounded-sm object-contain"
                        src={asset.src}
                        alt={assetLabel}
                        loading="lazy"
                      />
                    )}
                    <span
                      className={`mt-1 line-clamp-2 w-full min-w-0 break-words px-[3px] text-xs font-normal leading-[14px] ${disabled ? "text-gray-400" : "text-black"}`}
                    >
                      {assetLabel}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};
